import { createAction, props } from '@ngrx/store';
import { ErrorMessage, RestApiError } from '../../errors/models/error-message';
import { AccountNameResult, MacAddressResult, PhoneNumberResult, SoftphoneUsernameResult } from '../models/global-search.model';

export const apiSearchIdFailed = createAction('[API] API Search Account Name Failed', props<RestApiError>());

export const globalSearchAccountsSearchResultFailure = createAction(
   '[Global Search] Accounts Search Result Failure',
   props<RestApiError>()
);

export const globalSearchAccountsSearchResultSuccess = createAction(
   '[Global Search] Accounts Search Result Success',
   props<{ accounts: AccountNameResult[] | undefined }>()
);

export const globalSearchSearchAccountIdFailed = createAction(
   '[Global Search] Search Ticket Id Updated Failed',
   props<ErrorMessage>()
);

export const globalSearchDevicesSearchResultFailure = createAction(
   '[Global Search] Devices Search Result Failure',
   props<RestApiError>()
);

export const globalSearchDevicesSearchResultSuccess = createAction(
   '[Global Search] Devices Search Result Success',
   props<{ devices: MacAddressResult[] | undefined }>()
);

export const globalSearchDeviceSearched = createAction(
   '[Global Search] Device  Searched',
   props<{ searchText: string }>()
);

export const globalSearchPhoneNumbersSearchResultFailure = createAction(
   '[Global Search] Phone Numbers Search Result Failure',
   props<RestApiError>()
);

export const globalSearchPhoneNumbersSearchResultSuccess = createAction(
   '[Global Search] Phone Numbers Search Result Success',
   props<{ phoneNumbers: PhoneNumberResult[] | undefined }>()
);

export const globalSearchSoftphoneUsernamesSearchResultFailure = createAction(
   '[Global Search] Softphone Usernames Search Result Failure',
   props<RestApiError>()
);

export const globalSearchSoftphoneUsernamesSearchResultSuccess = createAction(
   '[Global Search] Softphone Usernames Search Result Success',
   props<{ softphoneUsernames: SoftphoneUsernameResult[] | undefined }>()
);

export const globalSearchSearchResultCleared = createAction('[Global Search] Search Result Cleared');

export const globalSearchSearchTextChanged = createAction(
   '[Global Search] Search Text Changed',
   props<{ searchText: string }>()
);
